import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { warehouseCardShellSx, type WarehouseCardVariant } from './warehouseCardVariants';

export type WarehouseCardShellProps = {
  variant?: WarehouseCardVariant;
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  'data-testid'?: string;
  sx?: object;
};

export const WarehouseCardShell: React.FC<WarehouseCardShellProps> = ({
  variant = 'statusSummary',
  title,
  subtitle,
  children,
  'data-testid': dataTestId,
  sx,
}) => {
  const theme = useTheme();
  return (
    <Paper
      variant="outlined"
      data-testid={dataTestId}
      sx={{ ...warehouseCardShellSx(variant, theme), ...(sx as object) }}
    >
      {title ? (
        <Box sx={{ mb: subtitle ? 0.35 : 1.15 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25, lineHeight: 1.45 }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
      ) : null}
      {children}
    </Paper>
  );
};
